import useSocialmedia from './use-socialmedia';

const useWhatsappLink = (text, number = undefined) => {
  const { whatsappNumberWithCountryCodeNL } = useSocialmedia();
  const phoneNumber = number || whatsappNumberWithCountryCodeNL;
  if (!phoneNumber) {
    return null;
  }

  return `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${text}`;
};

export default useWhatsappLink;
